module.exports = __webpack_public_path__ + "static/media/paw.1b83ffdc.JPG";